import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const useResponsive = () => {
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isNotMobile = useMediaQuery({ minWidth: 768 });
  const isDark = useMediaQuery({ query: '(prefers-color-scheme: dark)' });

  useEffect(() => {
    setIsTouchScreen(
      typeof window !== undefined && typeof navigator !== undefined && navigator.maxTouchPoints > 0,
    );
  }, []);

  let type;
  if (isMobile) type = 'mobile';
  if (isTablet) type = 'tablet';
  if (isDesktop) type = 'desktop';
  return { isMobile, isTablet, isDesktop, isNotMobile, type, isDark, isTouchScreen };
};

export default useResponsive;
